import axios from 'axios';

const adminApi = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8001/api/',
    headers: { 'Content-Type': 'application/json' },
});

adminApi.interceptors.request.use((config) => {
    const token = localStorage.getItem('admin_access_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    if (config.url) config.url = config.url.replace(/\/+$/, '');
    return config;
});

adminApi.interceptors.response.use(
    (res) => res,
    (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            localStorage.removeItem('admin_access_token');
            window.location.href = '/admin/login';
        }
        return Promise.reject(error);
    }
);

export default adminApi;
